import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { format } from 'date-fns';

import { Bank } from '../../../types/payment-config.type';
import styles from '../../payment-form/payment-form.module.scss';
import Input from '../../input/input';

type MobilePaymentData = {
    bankId: number;
    date: string;
    phone: string;
    nin: string;
    referenceCode: string;
};

type Props = {
    banks: Bank[];
    onData: (data: MobilePaymentData) => void;
};

const MobilePaymentForm = ({ banks, onData }: Props) => {
    const [bankId, setBankId] = useState(0);
    const [date, setDate] = useState('');
    const [phone, setPhone] = useState('');
    const [nin, setNin] = useState('');
    const [referenceCode, setReferenceCode] = useState('');

    useEffect(() => {
        onData({ bankId, date, phone, nin, referenceCode });
    }, [bankId, date, phone, nin, referenceCode]);

    const selectBank = useCallback((ev: ChangeEvent<HTMLSelectElement>) => {
        setBankId(Number(ev.target.value));
    }, []);

    const selectDate = (strDate: string) => {
        const date = format(
            new Date(strDate.replaceAll('-', '/')),
            'dd/MM/yyyy'
        );
        setDate(date);
    };

    return (
        <form className={styles.paymentForm}>
            <div className={styles.info}>
                <span>Utilizando Pago Móvil:</span>
                <b>Banco Venezolano de Crédito</b>
                <b>J-410713747</b>
                <b>0424-2479718</b>
            </div>

            <select
                className={styles.selectField}
                value={bankId}
                onChange={selectBank}
            >
                <option value="" disabled>
                    — Seleccione su Banco —
                </option>
                {banks.map((bank) => (
                    <option key={bank.code} value={bank.id}>
                        ({bank.code}) {bank.name}
                    </option>
                ))}
            </select>

            <Input
                placeholder={'Fecha del pago'}
                onInput={selectDate}
                type="date"
            />

            <Input
                placeholder={'Número de Celular del pagador'}
                onInput={setPhone}
                type="tel"
                maxLength={11}
            />

            <Input
                placeholder={'Cédula Identidad del pagador'}
                onInput={setNin}
                maxLength={12}
            />

            <Input
                placeholder={'Número de referencia'}
                onInput={setReferenceCode}
            />
        </form>
    );
};

export { MobilePaymentForm };
